import { Injectable, inject } from '@angular/core';
import {
  ApiDependencyProviderService,
  CollectionRequest,
  CollectionResponse,
} from '@web/common';
import { map, Observable } from 'rxjs';
import { BrandSocialMediaCollectionItemResponse } from '../../../shared/api/responses/brand-social-media-collection-item.response';

@Injectable({
  providedIn: 'root',
})
export class AdminBrandSocialMediaApiService {
  private readonly provider = inject(ApiDependencyProviderService);

  public fetchCollection(
    request: CollectionRequest,
    cacheable = false,
  ): Observable<CollectionResponse<BrandSocialMediaCollectionItemResponse>> {
    const path = 'admin/dictionary/social-network';
    const url = this.provider.httpUrlFactory.withQueryParams(
      this.hostUrl(),
      path,
      this.provider.httpHelper.collectionRequestToQueryParams(request),
    );
    const context = this.provider.httpContextBuilder
      .withOptionalCacheInterceptor(() => cacheable)
      .build();

    return this.provider.http
      .get(url, { context })
      .pipe(
        map(
          this.provider.httpHelper.bodyToCollectionResponse(
            BrandSocialMediaCollectionItemResponse,
          ),
        ),
      );
  }

  protected hostUrl(): string {
    return this.provider.environment.ApiHostUrl.Shop;
  }
}
